module.exports = __webpack_public_path__ + "img/set-default-gray.f0d12fba.svg";